@if (profileContext$ | async; as profileContext) {
  <div class="nav-header">
    <a class="logo" [class.collapsed]="collapsed" routerLink="/">
      <img
        [src]="(collapsed ? smRenownedLogoPath : lgRenownedLogoPath) | staticImageUrl"
        [alt]="('dashboard.brand' | transloco) + ' Logo'"
        [class]="collapsed ? 'w-[2.1rem]' : ''"
      />
    </a>
    <button type="button" class="toggle-icon" [class.collapsed]="collapsed">
      <rma-icon [glyph]="collapsed ? 'chevron_right' : 'chevron_left'" [rounded]="true" (click)="toggleSideNav.emit(!collapsed)" />
    </button>
  </div>
  <div *transloco="let t; prefix: 'side-nav'" class="nav" [class.collapsed]="collapsed">
    <rma-nav-profile-menu
      [style.display]="collapsed ? 'none' : 'flex'"
      [userAgency]="agencyName$ | async"
      [profile]="profileContext"
      [backgroundColour]="backgroundColour$ | async"
      [currentPlanName]="currentPlanName$ | async"
      [rating]="profileRating$ | async"
      (navigated)="onNavigate()"
    />
    @if (sideNavigationService.currentUrl$ | async; as currentUrl) {
      <mat-nav-list aria-label="Dashboard Navigation">
        @for (group of sideNavigationService.navigation$ | async; track $index) {
          @if (group.title && !collapsed) {
            <h3 class="nav-title">{{ t('menu.group.' + group.title) }}</h3>
          }
          @for (item of group.items; track item.label) {
            @if (item | typeGuard: isMenu; as menu) {
              <rma-sub-menu
                [item]="menu"
                [currentUrl]="currentUrl"
                [menuActive]="menu | isSubMenuOpen: currentUrl"
                [collapsed]="collapsed"
                (navigated)="onNavigate()"
                (menuExpanded)="onMenuExpanded($event)"
              />
            }
            @if (item | typeGuard: isItem; as item) {
              <rma-nav-menu-item
                [item]="item"
                [isActive]="item | isNavMenuItemActive: currentUrl"
                [collapsed]="collapsed"
                (navigated)="onNavigate()"
              />
            }
          }
        }
      </mat-nav-list>
    }
  </div>
  @if (profileUser$ | async; as profileUser) {
    <rma-nav-accounts-footer
      [profile]="profileUser.profile"
      [hasMultipleProfiles]="profileUser.user.hasMultipleProfiles"
      [collapsed]="collapsed"
    />
  }
}
